import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl-next';

import { LinkButton } from '@atlaskit/button/new';

import { ConfluencePageSubType } from '@confluence/create-blank-fabric-page/entry-points/CreateBlankPageMutation';
import { buildCreationLink } from '@confluence/create-blank-fabric-page/entry-points/createContentRouteUtils';
import { useIsLivePagesFeatureEnabled } from '@confluence/live-pages-utils/entry-points/useIsLivePagesFeatureEnabled';

const i18n = defineMessages({
	createPage: {
		id: 'home.home-views.create-page',
		defaultMessage: 'Create a page',
		description: 'Text of a button which, when clicked, creates a page',
	},
	createLivePage: {
		id: 'home.home-views.create-live-doc',
		defaultMessage: 'Create a live doc',
		description: 'Text of a button which, when clicked, creates a live page',
	},
});

export const CreatePageButton = ({ appearance, creationLinkSource, showCreateLivePageButton }) => {
	const { isLivePagesFeatureEnabled } = useIsLivePagesFeatureEnabled();
	const creationHref = buildCreationLink({
		contentType: 'page',
		source: creationLinkSource,
		withFallback: true,
		subType: isLivePagesFeatureEnabled ? ConfluencePageSubType.LIVE : undefined,
	});

	return (
		<LinkButton href={creationHref} appearance={appearance} shouldFitContainer={false}>
			<FormattedMessage
				{...(showCreateLivePageButton && isLivePagesFeatureEnabled
					? i18n.createLivePage
					: i18n.createPage)}
			/>
		</LinkButton>
	);
};
